import { createFileRoute, redirect } from '@tanstack/react-router';

import { Storage } from '#modules/user/features/profile/components/Settings/Storage';
import { envConfig } from '#constants/envConfig';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/storage'
)({
  component: Storage,
  ssr: false,
  /**
   * Хранилище картинок живёт только в приложении. В браузере картинками распоряжается сам браузер,
   * и прямой адрес этого раздела ведёт обратно к списку настроек.
   */
  beforeLoad: () => {
    if (!envConfig.IS_NATIVE) {
      throw redirect({ to: '/{-$locale}/dashboard/settings', replace: true });
    }
  },
});
